import { minValue, number, regex, required, maxValue } from "admin-on-rest";

export const requireValidation = [required]

export const numberMinValidation = [number, minValue(0)]
export const requiredAndNumberMinValidation = [number, minValue(0.01), maxValue(99.99), required]

export const requiredWithRegexpValidation = [
  required,
  regex(/^[a-z]*\.[a-z]*\.[a-zA-z0-9.]{1,}$/, 'Expected format: com.fortunica.xxxxx ')
];

export const validateProductCreation = (values) => {
  const errors = {}
  if (!values.title) {
    errors.title = ['The title is required']
  }
  if (!values.identifier) {
    errors.identifier = ['The identifier is required']
  }
  if (!values.icon) {
    errors.icon = ['The icon is required']
  }
  if (!values.previewImage) {
    errors.previewImage = ['The previewImage is required']
  }
  return errors
}

export const validatePackage = (values, showWarn = () => {}, hideWarn = () => {}) => {
  const { creditValue } = values
  let hasValue = false
  const isHideWarn = !Object.values(creditValue || {}).some((credit) => {
    if (!credit) {
      return false
    }
    if (hasValue) {
      showWarn()
      return true
    }
    hasValue = true
    return false
  })
  if (isHideWarn) {
    hideWarn()
  }
  return {}
}



// WEBPACK FOOTER //
// ./src/utils/validation.js